class CollectionPaginationLabel extends window.BAO.CustomElement({
  SuperClass: HTMLParagraphElement,
}) {
  constructor () {
    super()
    this._mutationObserver = null
  }

  connectedCallback () {
    const externalLabel = document.querySelectorAll(
      '[data-collection-pagination-label-external-el="label"]',
    )

    if (externalLabel[1]) {
      this.textContent = externalLabel[1].textContent
    }
  }
}

customElements.define(
  'collection-pagination-label',
  CollectionPaginationLabel,
  {
    extends: 'p',
  },
)
